var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
        'mix-grid-block',
        _vm.scroll && 'mix-grid-block-scroll',
        _vm.scrollMobileOnly && 'mix-grid-block-scroll-mobile-only',
        _vm.padded && 'mix-grid-block-padded',
    ]},_vm._l((_vm.mixes),function(mix,index){return _c('div',{key:'mix-grid-tile' + mix.id + index + Math.random(),staticClass:"tile"},[_c(_setup.MixGridTile,{attrs:{"mix":mix,"index":index}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }